import React from "react";
import clsx from "clsx";

import useContactProfilePic from "../../hooks/useContactProfilePic";
import { resolveChannelBadge } from "../../helpers/channelBadge";
import { IconUserStatus } from "./tailwickChatIcons";

function IconUsersGroup({ size = 18 }) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			className="shrink-0 text-default-500"
			aria-hidden
		>
			<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
			<circle cx="9" cy="7" r="4" />
			<path d="M22 21v-2a4 4 0 0 0-3-3.87" />
			<path d="M16 3.13a4 4 0 0 1 0 7.75" />
		</svg>
	);
}

function IconEmailBadge() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={14}
			height={14}
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			className="text-primary"
			aria-hidden
		>
			<path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
			<polyline points="22,6 12,13 2,6" />
		</svg>
	);
}

function ChannelBadgeOverlay({ channel, contactChannel, size }) {
	const badge = resolveChannelBadge(channel, contactChannel);
	if (!badge) return null;

	return (
		<span
			className={clsx(
				"tailwick-contact-avatar__channel-badge",
				size === "md" && "tailwick-contact-avatar__channel-badge--md"
			)}
			aria-hidden
		>
			{badge.kind === "email" ? (
				<IconEmailBadge />
			) : (
				<img src={badge.src} alt="" />
			)}
		</span>
	);
}

const SIZE_MAP = {
	sm: { wrap: "tailwick-contact-avatar--sm", icon: 18 },
	md: { wrap: "tailwick-contact-avatar--md", icon: 20 },
};

export default function TailwickContactAvatar({
	size = "sm",
	contactId,
	profilePicUrl = "",
	profilePicSource,
	isGroup = false,
	className = "",
	channel,
	contactChannel,
	statusHighlight = false,
	syncProfilePic = true,
}) {
	const { src, failed, handleError } = useContactProfilePic({
		contactId,
		profilePicUrl: profilePicUrl || profilePicSource || "",
		channel: channel || contactChannel,
		enableSync: syncProfilePic,
	});

	const dims = SIZE_MAP[size] || SIZE_MAP.sm;
	const showImage = Boolean(src) && !failed;

	return (
		<div
			className={clsx(
				"tailwick-contact-avatar",
				dims.wrap,
				statusHighlight && "tailwick-contact-avatar--status",
				className
			)}
		>
			<div className="tailwick-contact-avatar__inner">
				{showImage ? (
					<img
						src={src}
						alt=""
						className="tailwick-contact-avatar__photo"
						onError={handleError}
					/>
				) : isGroup ? (
					<IconUsersGroup size={dims.icon} />
				) : (
					<IconUserStatus size={dims.icon} />
				)}
			</div>
			<ChannelBadgeOverlay
				channel={channel}
				contactChannel={contactChannel}
				size={size}
			/>
		</div>
	);
}
